import { cn } from 'utils/cn';

/** A spinner, as every running thing in the AI surfaces draws one; it pulses under reduced motion. */
export function Spinner({ className }: { className?: string }) {
    return (
        <span
            aria-hidden="true"
            className={cn(
                'border-border border-t-foreground size-3.5 rounded-full border-[1.5px] motion-safe:animate-spin motion-reduce:animate-pulse',
                className
            )}
        />
    );
}
